import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  LOCALE_ID,
  isDevMode,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { ApiModule, Configuration } from './openapi';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideRouterStore } from '@ngrx/router-store';
import { metaReducers, reducers } from './store/reducers/app.reducer';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { AppEffects } from './store/effects/app.effects';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { AuthInterceptor } from './services/auth.interceptor';
import { ApplicationEffects } from './store/effects/application.effects';

import '@angular/common/locales/global/pl';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { UserDetailsEffects } from './store/effects/user-details.effects';

import 'dayjs/locale/pl';
import dayjs from 'dayjs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MyCasesEffects } from './store/effects/my-cases.effects';

dayjs.locale('pl');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled'
    })),
    importProvidersFrom(
      HttpClientModule,
      ApiModule.forRoot(() =>
        new Configuration({
          basePath: environment.apiBasePath
        })
      ),
      BrowserModule,
      BrowserAnimationsModule
    ),
    provideStore(reducers, { metaReducers }),
    provideRouterStore(),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'dd.MM.yyyy' } },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'PLN' },
    { provide: LOCALE_ID, useValue: 'pl-PL' },
    provideEffects([AppEffects, ApplicationEffects, UserDetailsEffects, MyCasesEffects]),
    provideEnvironmentNgxMask()
  ]
};
